var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLyric(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 26.1667H21C21.6189 26.1667 22.2124 25.9209 22.6499 25.4833C23.0875 25.0457 23.3334 24.4522 23.3334 23.8334V8.66671L17.5 2.83337H7.00002C6.38118 2.83337 5.78769 3.07921 5.3501 3.51679C4.91252 3.95438 4.66669 4.54787 4.66669 5.16671V14.9667",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33331 21.5V12.5167L18.6666 11V19.1667",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3333 21.5C17.622 21.5 18.6667 20.4554 18.6667 19.1667C18.6667 17.878 17.622 16.8334 16.3333 16.8334C15.0447 16.8334 14 17.878 14 19.1667C14 20.4554 15.0447 21.5 16.3333 21.5Z",
    fill: "#FF8B63",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00002 23.8333C8.28868 23.8333 9.33335 22.7886 9.33335 21.5C9.33335 20.2113 8.28868 19.1666 7.00002 19.1666C5.71136 19.1666 4.66669 20.2113 4.66669 21.5C4.66669 22.7886 5.71136 23.8333 7.00002 23.8333Z",
    fill: "#FF8B63",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLyric);
export default __webpack_public_path__ + "static/media/Icon-Lyric.8824fd85b33d808033e37424860c882b.svg";
export { ForwardRef as ReactComponent };